import React from "react";

const Skeleton = ({ units }) => {
  return (
    <>
      {Array.from({ length: units }, (_, i) => (
        <div className="skeleton" key={i}></div>
      ))}
    </>
  );
};

export default Skeleton;
